export default __webpack_public_path__ + "./images/ec.cffe82bc.png";